import { useEffect, useState } from "react";
import {
  Popconfirm,
  Space,
  Typography,
  Col,
  Input,
  Row,
  Select,
  notification,
} from "antd";
const { Search } = Input;
import { Content } from "antd/lib/layout/layout";
import { useDispatch, useSelector } from "react-redux";
import { PayloadType, ShareDataType } from "type";
import Table, { ColumnsType } from "antd/lib/table";
import queryString from "query-string";
import { getProductTemps } from "features/productTempSlice";
import { deleteSharedData, getSharedDatas } from "features/sharedDataSlice";
import { deleteProductTemps } from "features/productTempSlice";
import _ from "lodash";
import CUFood from "./CUFood";
const { Title } = Typography;
function Food() {
  const dispatch = useDispatch();

  const [searchText, setSearchText] = useState<any>(undefined);
  const [listFood, setListFood] = useState<any>([]);
  const [query, setQuery] = useState<any>({ page: 1, limit: 10 });
  const [rowUpdate, setRowUpdate] = useState<any>(null);
  const [typeGroupId, setTypeGroupId] = useState<ShareDataType | "">("");
  const handleSearch = () => {
    setQuery({
      ...query, // lấy lại những thuộc tính về query ban đầu được lấy từ useReducer
      codeOrName: !_.isEmpty(searchText) ? searchText : undefined,
      page: 1, //Trường lọc data là name và
      limit: 10,
    });
  };

  //desc column
  const columns: ColumnsType<ShareDataType> = [
    {
      title: "Mã thức ăn",
      dataIndex: "code",
      key: "code",
      align: "left",
      render(value) {
        return value;
      },
      width: 100,
    },

    {
      title: "Tên thức ăn",
      dataIndex: "name",
      key: "name",
      align: "left",
      width: 400,
    },
    {
      title: "Nhà cung cấp",
      dataIndex: "supplier",
      key: "supplier",
      align: "left",
    },
    {
      title: "Giá tiền (vnđ)",
      dataIndex: "price",
      key: "price",
      align: "left",
      render: (value) => {
        return (
          <div style={{ textAlign: "right" }}>
            {`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
          </div>
        );
      },
    },

    {
      title: "Ghi chú",
      dataIndex: "description",
      key: "description",
      align: "left",
    },

    {
      title: "Hành động",
      dataIndex: "action",
      key: "action",
      align: "center",
      render: (_, record: any) => {
        return (
          <Space>
            <a
              onClick={() => {
                setRowUpdate(record);
              }}
            >
              Sửa
            </a>
            <Popconfirm
              title={"Bạn có chắc chắn muốn xóa mục này không ?"}
              okText={"Có"}
              cancelText={"Không"}
              onConfirm={() => {
                const id = record?.id ?? "";
                if (id) {
                  const payload: PayloadType = {
                    params: id,
                    callback: {
                      success(values) {
                        notification.success({
                          message: "Xoá danh mục tên thức ăn thành công!",
                        });
                        getListFood(typeGroupId, query);
                      },
                      failed(errorMessage) {
                        notification.error({
                          message: "Xoá danh mục tên thức ăn thất bại!",
                          description: errorMessage,
                        });
                      },
                    },
                  };
                  dispatch(deleteProductTemps(payload));
                }
              }}
            >
              <a>Xoá</a>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  // Danh sách danh mục tên thức ăn
  const getTypeGroup = () => {
    const payload: PayloadType = {
      query: queryString.stringify({
        code: "FOOD_TYPE",
      }),
      callback: {
        success(dataTypeGroup) {
          if (dataTypeGroup?.results && dataTypeGroup.results.length > 0) {
            setTypeGroupId(dataTypeGroup.results[0].id);

            // Tiếp tục xử lý nếu có dữ liệu
            const payload: PayloadType = {
              query: queryString.stringify({
                page: 1,
                limit: 10,
                productTypeId: dataTypeGroup.results[0].id,
              }),
              callback: {
                success(res) {
                  setListFood(res);
                },
                failed() {},
              },
            };
            dispatch(getProductTemps(payload));
          } else {
          }
        },
        failed() {},
      },
    };
    dispatch(getSharedDatas(payload));
  };

  useEffect(() => {
    getTypeGroup();
  }, []);

  // Lấy loại của sản phẩm hiện tại

  const getListFood = (typeGroupId: any, query: any) => {
    const payload: PayloadType = {
      query: queryString.stringify({
        ...query,
        productTypeId: typeGroupId,
      }),
      callback: {
        success(res) {
          setListFood(res);
        },
        failed() {},
      },
    };
    dispatch(getProductTemps(payload));
  };

  useEffect(() => {
    if (typeGroupId !== "") {
      getListFood(typeGroupId, query);
    }
  }, [query, typeGroupId]);

  return (
    <Content className="custom-layout-content">
      <Row
        style={{
          height: "70px",
          marginBottom: "16px",
          lineHeight: "70px",
          padding: "16px 24px",
        }}
        className="background-content-layout"
      >
        <Col span={24}>
          <div className="space-between">
            <Title
              level={4}
              style={{
                marginBottom: "0px",
                height: "40px",
                lineHeight: "40px",
              }}
            >
              Danh mục tên thức ăn
            </Title>
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={6}>
          <div
            className="background-content-layout"
            style={{
              padding: "24px",
              marginRight: "8px",
            }}
          >
            <>
              <div className="space-between">
                <Title
                  level={4}
                  style={{
                    marginBottom: "20px",
                    height: "40px",
                    lineHeight: "40px",
                  }}
                >
                  {Object.keys(rowUpdate ?? {}).length === 0
                    ? "Thêm mới"
                    : "Cập nhật"}
                </Title>
              </div>
              <CUFood
                typeGroupId={typeGroupId}
                rowUpdate={rowUpdate}
                getListFood={getListFood}
                setRowUpdate={setRowUpdate}
                query={query}
              />
            </>
          </div>
        </Col>
        <Col span={18}>
          <div
            className=" background-content-layout"
            style={{ padding: "24px 16px", marginLeft: "8px" }}
          >
            <div
              className="space-between"
              style={{
                marginBottom: "20px",
                height: "40px",
                lineHeight: "40px",
                paddingLeft: "10px",
              }}
            >
              <Title level={5}>Danh sách</Title>
              <Space className="custom-placeholder-select">
                <Search
                  placeholder="Tìm kiếm theo mã hoặc tên thức ăn "
                  onChange={(e) => setSearchText(e.target.value)}
                  onSearch={handleSearch}
                  style={{ width: 282 }}
                />
              </Space>
            </div>

            <Table
              style={{ marginLeft: "8px" }}
              className=""
              rowKey={"id"}
              columns={columns}
              dataSource={_.get(listFood, "results", [])}
              pagination={{
                current: _.get(listFood, "page", 1),
                pageSize: _.get(listFood, "limit", 1),
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                total: _.get(listFood, "totalResults", 1),
                showTotal: (total, range) => {
                  return `Có tất cả ${total} bản ghi`;
                },
                onChange(page, pageSize) {
                  setQuery({
                    ...query,
                    page: page,
                    limit: pageSize,
                  });
                },
              }}
            />
          </div>
        </Col>
      </Row>
    </Content>
  );
}

export default Food;
